import { IAffiliateAllLang } from '../../../types/lang'
import { affiliateCrudModalLang } from './affiliateCrudModal'
import { affiliatePageLang } from './affiliatePage'
import { affiliateListTableLang } from './affiliateListTable'

export const affiliateAllLang: IAffiliateAllLang = {
	...affiliatePageLang,
	...affiliateCrudModalLang,
	...affiliateListTableLang
}